<template>
  <v-footer fixed inset app
    class="cli-records--footer pt-0 px-0">
    <v-tabs
      v-model="form.type"
      background-color="transparent"
      @change="search()">
      <v-tab v-for="item in getPostTypeItems" :key="item.slug">{{ item.label }}</v-tab>
      <v-row dense v-if="getPostType === 'tutor'"
        class="align-center px-6">
        <v-spacer></v-spacer>
        <v-menu>
          <template v-slot:activator="{ on }">
            <v-btn text
              v-on="on"
              color="secondary">{{ `個別指導：${printTotalWageTime}時間` }}</v-btn>
          </template>
          <v-list>
            <v-list-item @click="open('biller', { entries: $props.items || [] })">
              <v-list-item-avatar>
                <v-icon>fal fa-copy</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>請求書を発行する</v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
    </v-tabs>
    <v-progress-linear indeterminate :color="isLoading ? 'secondary' : 'transparent'"></v-progress-linear>
    <v-list-item dense class="pl-2 pr-6 grey lighten-2 ">
      <v-list-item-avatar class="mr-2">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn fab text small v-on="on" color="secondary" :disabled="isLoading" @click="search(form.primary)">
              <v-icon small>fal fa-search</v-icon>
            </v-btn>
          </template>
          <span>検索する</span>
        </v-tooltip>
      </v-list-item-avatar>
      <v-list-item-content class="py-0 white" style="border-radius:4px">
        <v-toolbar dense flat color="transparent" class="px-2">
          <v-text-field solo flat rounded hide-details
            v-model="form.primary"
            placeholder="件名・本文から検索する"
            @keypress.enter.prevent="search(form.primary)"
          />
          <v-divider vertical class="mr-2"></v-divider>
          <v-menu
            v-model="config.datepickers.posted"
            :close-on-content-click="false"
            max-width="290">
            <template v-slot:activator="{ on }">
              <v-btn fab text small
                v-on="on"
                color="secondary"
                @click="form.posted = []">
                <v-badge left overlap
                  :content="printFormattedPostedDates"
                  :color="printFormattedPostedDates ? 'red' : 'transparent'">
                  <v-icon small>fal fa-calendar-alt</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-date-picker range no-title
              v-model="form.posted"
              locale="ja"
              color="amber"
              :day-format="date => new Date(date).getUTCDate()"
            />
          </v-menu>
          <v-divider vertical class="mx-2"></v-divider>
          <v-btn-toggle mandatory dense
            v-if="$vuetify.breakpoint.smAndUp"
            v-model="form.view"
            class="grey lighten-3"
            @change="change">
            <v-btn :text="form.view !== 'cards'" :depressed="form.view === 'cards'" color="secondary white--text" value="cards">
              <v-icon size="20" :class="form.view === 'cards' ? 'white--text' : ''">fal fa-th</v-icon>
            </v-btn>
            <v-btn :text="form.view !== 'items'" :depressed="form.view === 'items'" color="secondary white--text" value="items">
              <v-icon size="20" :class="form.view === 'items' ? 'white--text' : ''">fal fa-th-list</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-toolbar>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon disabled></v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-speed-dial absolute bottom right open-on-hover
      direction="top"
      transition="slide-y-reverse-transition">
      <template v-slot:activator>
        <v-btn fab
          color="secondary"
          :disabled="isLoading"
          @click="open('inserter', { type: 'post' })">
          <v-icon>fal fa-pencil</v-icon>
        </v-btn>
      </template>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn fab
            v-on="on"
            color="secondary--text"
            @click="open('inserter', { type: 'tutor' })">
            <v-icon>fa-book-reader</v-icon>
          </v-btn>
        </template>
        <span>個別指導を投稿する</span>
      </v-tooltip>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn fab
            v-on="on"
            color="secondary--text"
            @click="open('inserter', { type: 'credit' })">
            <v-icon>fa-credit-card</v-icon>
          </v-btn>
        </template>
        <span>カード決済を投稿する</span>
      </v-tooltip>
    </v-speed-dial>
    <Inserter ref="inserter" />
    <Biller ref="biller" />
  </v-footer>
</template>

<script>
import Inserter from './modals/insert'
import Biller from './modals/bill'
const DEF = {
  form: {
    primary: '',
    type: 0,
    author: '',
    posted: [],
    view: 'cards'
  }
}
export default {
  name: 'clientRecordFooter',
  props: [ 'types', 'status', 'items' ],
  components: {
    Inserter,
    Biller
  },
  data () {
    return {
      config: {
        type: 'post',
        status: {
          loading: false,
          search: false
        },
        datepickers: {
          posted: false
        }
      },
      meta: {
        types: {
          record: '対応履歴',
          credit: 'カード決済',
          tutor: '個別指導',
          transfer: '海外送金'
        }
      },
      form: {
        primary: this.$route.query && this.$route.query.query || '',
        type: 0,
        author: '',
        posted: [],
        view: this.$vuetify.breakpoint.smAndUp ? 'cards' : 'items'
      }
    }
  },
  methods: {
    search: function (query) {
      const isBothNull = !this.$route.query.query && !query
      if (!isBothNull && this.$route.query.query !== query) {
        this.$router.push({ query: query ? { query } : {}})
      }
      this.$set(this.form, 'primary', query || '')
      this.$set(this.config.status, 'search', false)
      this.$emit('search')
    },
    reset: function () {
      const { view } = this.form
      this.$set(this, 'form', Object.assign(JSON.parse(JSON.stringify(DEF.form)), { view }))
    },
    change: function (req) {
      this.$emit('change', req)
    },
    open: function (name, req) {
      if (this.$refs[name]) {
        this.$refs[name].open(req)
      }
    },
    getForm: function () {
      return this.form
    }
  },
  watch: {
    'form.posted': function (newVal, oldVal) {
      if (newVal.join('') !== oldVal.join('')) {
        this.search(this.form.primary)
      }
    }
  },
  computed: {
    isLoading () {
      return this.$props.status && this.$props.status.loading
    },
    printTotalWageTime () {
      return (this.$props.items && this.$props.items.length) ? this.$props.items.reduce((prev, current) => {
        const content = current.content ? JSON.parse(current.content) : { wage: 0 }
        // eslint-disable-next-line
        const wage = content.wage ? `${content.wage}`.replace(/[０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
          }) : '0'
        return prev + (isFinite(wage) ? parseFloat(wage) : 0)
      }, 0) : 0
    },
    printFormattedPostedDates () {
      const [ dateA, dateB ] = this.form.posted
      if (this.form.posted.length === 2) {
        if (this.$moment(dateA).isBefore(dateB)) {
          return `${this.$moment(dateA).format('YY.MM.DD')} ~ ${this.$moment(dateB).format('YY.MM.DD')}`
        } else {
          return `${this.$moment(dateB).format('YY.MM.DD')} ~ ${this.$moment(dateA).format('YY.MM.DD')}`
        }
      } else if (this.form.posted.length === 1) {
          return `${this.$moment(dateA).format('YY.MM.DD')}`
      } else {
        return ''
      }
    },
    getPostTypeItems () {
      return this.$props.types ? this.$props.types : []
    },
    getPostType () {
      return this.$props.types && this.$props.types[this.form.type] && this.$props.types[this.form.type].slug
    },
    getViewType () {
      return this.form.view
    },
    getAuthorItems () {
      const authors = this.$store.getters['config/get']('authors')
      const keys = Object.keys(authors)
      return keys.filter(key => { return !!authors[key].belong }).map(key => {
        return {
          text: authors[key].name[0],
          value: authors[key].name[0]
        }
      })
    },
    getTypeItems () {
      return Object.keys(this.meta.types).map(key => {
        return {
          text: this.meta.types[key],
          value: key
        }
      })
    },
    printMinDateFormat () {
      return this.form.minDate ? this.$moment(this.form.minDate).format('YYYY/MM/DD') : ''
    },
    printMaxDateFormat () {
      return this.form.maxDate ? this.$moment(this.form.maxDate).format('YYYY/MM/DD') : ''
    }
  }
}
</script>